export const buildFetchHandler = (handler) => {
    if (typeof handler === 'object') {
        return handler.handle.bind(handler);
    }
    return handler;
};
export const simpleFetchHandler = ({ service, fetch: _fetch = fetch, }) => {
    return async (pathname, init) => {
        const url = new URL(pathname, service);
        return _fetch(url, init);
    };
};
//# sourceMappingURL=fetch-handler.js.map